// Copyright (c) 2023 Deere & Company

import React, {PropTypes} from 'react';
import ConfirmDeleteButton from './confirm-delete-button-cloud';
import File from '@deere/cps-it.warranty-model-factory/lib/file';
import {downloadFile} from '../../../../../tcsm/wip/services/file-download';

function onFileClick(file) {

    downloadFile(file);

}

const FileAttachmentList = props =>
    <section className='file-attachments'>
        <ul>
            {
            props.files.map((file, index) =>
                <li key={index}>
                    <button
                        className='button-text button-link'
                        onClick={onFileClick.bind(null, file)}
                    >
                        {file.fileName}
                    </button>
                    <ConfirmDeleteButton
                        file={file}
                        onDelete={props.onFileDelete}
                    />
                </li>
            )
        }
        </ul>
    </section>;

FileAttachmentList.displayName = 'FileAttachmentList';

FileAttachmentList.propTypes = {
    files: PropTypes.arrayOf(PropTypes.instanceOf(File)).isRequired,
    onFileDelete: PropTypes.func.isRequired
};

export default FileAttachmentList;



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/components/duplicate-pin-plate-form/file-attachment-panel-cloud/file-attachment-list-cloud.js